<template>
  <section>
    <div class="page">
      <div>
        <h2>Making changes to groups</h2>
        <p>
          By default, any group admin can change the subject, icon, description,
          and settings.
        </p>
        <p>
          The original creator of a group can't be removed and will always
          remain an admin unless they exit the group.
        </p>
        <h3>Changing the group settings</h3>
        <p>To change the group settings for joining into the group:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management</strong> >
            <strong>Join Group Settings</strong>.
          </li>
          <li>
            Choose to <strong>Allow Anyone to Join</strong>,
            <strong>Approval Needed</strong>, or
            <strong>Forbid Anyone to Join</strong> into the group.
          </li>
        </ol>
        <p>To change the group settings for sending messages:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management</strong> > <strong>Group Ban</strong>.
          </li>
          <li>
            Choose to allow <strong>All Participants</strong> or
            <strong>Only Admins</strong> to send messages. .
          </li>
        </ol>

        <h3>Changing the group name</h3>
        <p>To change the name:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management</strong> > <strong>Group Name</strong>.
          </li>
          <li>Enter a new name, then tap <strong>Save</strong>.</li>
          <ul>
            <li>The subject limit is 20 characters.</li>
          </ul>
        </ol>

        <h3>Changing the group avatar</h3>
        <p>To change the avatar</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management</strong> >
            <strong>Group Avatar</strong>.
          </li>
          <li>
            You can take a new photo with your camera or choose a photo from
            your albums.
          </li>
        </ol>

        <h3>Muting group notifications</h3>
        <p>
          You can mute group notifications for a specified period of time.
          You'll still receive messages sent to the group, but your phone won't
          vibrate or make noise when they're received.
        </p>
        <p>To mute notifications:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Mute Notifications</strong>.</li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
